import { ReactElement } from 'react';

import { AttributeValuesChecklist } from '@components/molecules/AttributeValuesChecklist';
import { ColorsFilter } from '@components/molecules/ColorsFilter';
import { TagsFilter } from '@components/molecules/TagsFilter';
import { AttributeChoiceTypeEnum } from '@sdk/gqlTypes/generatedTypes';

import { IFilters, ISingleFilterAttribute } from '../../../types';
// import { Range } from '../../atoms';

const checkIfAttributeIsChecked = (
  filters: IFilters,
  value: ISingleFilterAttribute,
  slug: string
): boolean => {
  // TODO: fixed eslint error. Check it.
  // if (filters!.attributes && filters.attributes.hasOwnProperty(slug)) {
  if (filters!.attributes && slug in filters.attributes) {
    if (filters.attributes[slug].find((filter) => filter === value.slug)) {
      return true;
    }
    return false;
  }
  return false;
};

const withSelected = (
  filters: IFilters,
  values: ISingleFilterAttribute[],
  slug: string
): ISingleFilterAttribute[] =>
  values
    .map((value: ISingleFilterAttribute) => ({
      ...value,
      selected: checkIfAttributeIsChecked(filters, value, slug),
    }))
    .filter((attr) => attr.slug !== 'values' && attr.slug !== 'inputtype'); // TODO: temp DB fix

interface Props {
  choiceType: AttributeChoiceTypeEnum | null;
  onFiltersChange: (
    attributeSlug: string,
    values: string | string[] | null
  ) => void;
  filters: IFilters;
  values: ISingleFilterAttribute[];
  slug: string;
}

export function AttributeTypeFilterInput({
  choiceType,
  onFiltersChange,
  filters,
  values,
  slug,
}: Props): ReactElement {
  /* if (choiceType === AttributeChoiceTypeEnum.SLIDER) {
    return (
      <Range
        values={withSelected(filters, values, slug)}
        onChange={(value) => {
          onFiltersChange(slug, value);
        }}
      />
    );
  } */
  if (choiceType === AttributeChoiceTypeEnum.SWATCH) {
    return (
      <ColorsFilter
        name={slug}
        values={withSelected(filters, values, slug)}
        onValueClick={(value) => onFiltersChange(slug, value.slug)}
      />
    );
  }
  if (choiceType === AttributeChoiceTypeEnum.DROPDOWN) {
    return (
      <TagsFilter
        name={slug}
        values={withSelected(filters, values, slug)}
        onValueClick={(value) => onFiltersChange(slug, value.slug)}
      />
    );
  }
  return (
    // fallback to checklist
    <AttributeValuesChecklist
      name={slug}
      values={withSelected(filters, values, slug)}
      onValueClick={(value) => onFiltersChange(slug, value.slug)}
    />
  );
}
